import React from "react";
import { Check } from "lucide-react";

// Reusable status timeline for orders and shipments.
// steps: [{ code, label }], currentCode: string, cancelledMessage: string
export default function StatusTimeline({ steps, currentCode, cancelledMessage }) {
  const isCancelled = currentCode === "cancelado" || currentCode === "cancelled";
  if (isCancelled) {
    return (
      <div
        data-testid="status-cancelled-banner"
        className="rounded-2xl border border-red-200 bg-red-50 text-red-800 px-5 py-4"
      >
        <div className="font-bold">Pedido cancelado</div>
        <p className="text-sm mt-0.5">{cancelledMessage}</p>
      </div>
    );
  }
  const idx = Math.max(
    0,
    steps.findIndex((s) => s.code === currentCode)
  );
  return (
    <ol
      data-testid="status-timeline"
      className="grid grid-cols-4 gap-2 sm:gap-4"
    >
      {steps.map((s, i) => {
        const done = i < idx;
        const current = i === idx;
        return (
          <li
            key={s.code}
            data-testid={`status-step-${s.code}`}
            className={`relative flex flex-col items-center text-center ${
              i > idx ? "opacity-50" : ""
            }`}
          >
            {i > 0 && (
              <div
                className={`absolute right-1/2 top-4 h-0.5 w-full ${
                  done || current ? "bg-[#00953B]" : "bg-neutral-200"
                }`}
                aria-hidden
              />
            )}
            <div
              className={`relative z-10 h-8 w-8 rounded-full grid place-items-center text-xs font-bold ${
                current
                  ? "bg-[#00953B] text-white ring-4 ring-[#00953B]/15"
                  : done
                  ? "bg-[#00953B] text-white"
                  : "bg-neutral-200 text-neutral-500"
              }`}
            >
              {done ? <Check className="h-4 w-4" /> : i + 1}
            </div>
            <div
              className={`mt-2 text-xs font-semibold ${
                current
                  ? "text-[#00753a]"
                  : done
                  ? "text-neutral-800"
                  : "text-neutral-400"
              }`}
            >
              {s.label}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
